<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          Messaging
        </h1>
      </div>
    </section>

    <section>
      <div class="tw-w-screen tw-p-2">
        <autocomplete-search
          api="/api/admin/profiles/search"
          :options="{
            placeholder: 'Search profiles',
            noResult: 'No profiles matching'
          }"
          :custom-label="(option) => `${option.nickname} (${option.name})`"
          @onSelect="onSelect"
        />

        <div class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-2">
          <ProfileGridItem
            v-for="profile in profiles"
            :key="profile.uuid"
            :data="profile"
            :route="{
              name: 'admin-profile'
            }"
            :options="{
              show: {
                profession: false,
                distanceToUser: true,
              }
            }"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PageNearby', // important
  components: {
    ProfileGridItem: () => import('@/components/profile/ProfileGridItem'),
  },

  data() {
    return {
      page: 1,
      profiles: [],
    };
  },

  methods: {
    onSelect(option) {
      this.$http
        .get('/api/admin/profiles/nearby', {
          params: {
            id: option.id,
          },
        })
        .then(({ data }) => {
          this.profiles = data;
        });
    },
  },
};
</script>
